<template>
	<div v-if="error" class="text-center mb-4">
		<div id="alert" class="alert alert-danger"><span>{{text}}</span></div>
	</div>
</template>
<script>
	export default {
		name: 'Error',
		props: ['error'],
		computed: {
			text() {
				if (!this.error) return null;
				const error = this.error;

				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					console.log(error.response);
					if (error.response.data) return error.response.data;
					return error.response.statusText
				} 
				else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log('No error response', error.request);
					return 'System unavailable. Please try again in a few minutes.';
				} 
				else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error setting up request', error.message);
					return error.message + '';
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Error.vue